import React from 'react';
import { Button } from 'react-bootstrap';
import Toggle from 'react-bootstrap-toggle';
import StringField from 'react-jsonschema-form/lib/components/fields/StringField';

export const ToggleButton = props => (
  <Toggle
    on="on"
    off="off"
    size="sm"
    className="toggle-switch"
    active={props.value === true}
    onClick={value => props.onChange(value)}
  />
);

export const DisabledToggleButton = (defaultValue = true) =>
  function DisabledToggleWithDefault() {
    return (
      <Toggle
        active={defaultValue}
        on="on"
        off="off"
        size="sm"
        className="toggle-switch"
        disabled
      />
    );
  };

export const ReverseToggleButton = props => (
  <Toggle
    on="on"
    off="off"
    size="sm"
    className="toggle-switch"
    active={props.value === false}
    onClick={value => {
      props.onChange(!value);
    }}
  />
);

export function TranslationRulesWithPreviewLink(props) {
  const {
    id,
    classNames,
    label,
    required,
    description,
    errors,
    formData,
  } = props;

  const selectedTranslationRulesId = formData;

  return (
    <div className={classNames}>
      <label htmlFor={id}>
        {label}
        {required ? '*' : null}
      </label>
      {description}
      <StringField {...props} />
      {errors}
      {process.env.REACT_APP_INSTORE_URL && selectedTranslationRulesId && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`${process.env.REACT_APP_INSTORE_URL}?previewTranslationRulesId=${selectedTranslationRulesId}`}
        >
          <Button bsStyle="link">Preview Translation Rules</Button>
        </a>
      )}
    </div>
  );
}
